// React
import React, {useState} from "react";

import { Form } from "react-bootstrap";

import {isEmpty as _isEmpty} from "lodash-es";

// Ant design
import { Button } from "antd";
import { PlusOutlined, FilterOutlined } from '@ant-design/icons';

// Eventify API
import * as EventifyAPI from "../libs/EventifyAPI";

import { useFormFields } from "../libs/hooksLib";

import PersonSelectionTypeahead from "./PersonSelectionTypeahead";

export default function ListTableAddPerson(props) {
  const [fields, handleFieldChange, clearFields] = useFormFields({
    email: "",
    notes: ""
  });
  const [name, setName] = useState("");
  const [selectedContact, setSelectedContact] = useState({});

  // TODO: don't use ref
  const nameTypeaheadRef = React.useRef();

  async function onUpdatePersonSelection(selected, type) {
    if (_isEmpty(selected)) {
      return;
    }
    let selectedPerson = selected[0];
    setSelectedContact(selectedPerson);
    setName(selectedPerson.name);
    handleFieldChange({target: {id: "email", value: selectedPerson.email || ""}})
  }

  function onInputChange(value) {
    setName(value);
  }

  function handleSubmit(e) {
    e.preventDefault();

    setName("");
    nameTypeaheadRef.current.clearFields();

    const addPersonData = {
      listId: props.listId,
      name: name,
      email: fields.email,
      notes: fields.notes,
      selectedContact: selectedContact
    };

    console.log(addPersonData);

    props.addPersonToList(addPersonData);

    clearFields();
    setSelectedContact({});
  }

  return <Form
    onSubmit={handleSubmit}
    className="list-table-add-person rdg-row"
    // swallow events so rdg doesn't try to focus this row/cell
    onClick={(e) => e.stopPropagation()}
    onMouseDown={(e) => e.stopPropagation()}
    onMouseUp={(e) => e.stopPropagation()}
  >
    <div
      className="rdg-cell"
      style={{
        left: props.rowProps.viewportColumns[0].left,
        width: props.rowProps.viewportColumns[0].width
      }}
    />
    <div
      className="rdg-cell"
      style={{
        left: props.rowProps.viewportColumns[1].left,
        width: props.rowProps.viewportColumns[1].width
      }}
    />
    <div
      className="rdg-cell typeahead"
      style={{
        left: props.rowProps.viewportColumns[2].left,
        width: props.rowProps.viewportColumns[2].width
      }}
    >
      <PersonSelectionTypeahead
        ref={nameTypeaheadRef}
        id="includePersonsName"
        title="Full Name"
        type="name"
        onUpdate={onUpdatePersonSelection}
        onInputChange={onInputChange}
        inListAlready={props.inListAlready}
      />
    </div>
    <div
      className="rdg-cell"
      style={{
        left: props.rowProps.viewportColumns[3].left,
        width: props.rowProps.viewportColumns[3].width
      }}
    >
      <Form.Control
        placeholder="Email"
        id="email"
        value={fields.email}
        onChange={handleFieldChange}
        disabled={!name}
      />
    </div>
    <div
      className="rdg-cell"
      style={{
        left: props.rowProps.viewportColumns[4].left,
        width: props.rowProps.viewportColumns[4].width
      }}
    >
      <Form.Control
        placeholder="Notes"
        id="notes"
        value={fields.notes}
        onChange={handleFieldChange}
        disabled={!name}
      />
    </div>
    {/*<div
      className="rdg-cell"
      style={{
        left: props.rowProps.viewportColumns[5].left,
        width: props.rowProps.viewportColumns[5].width
      }}
    />*}
    {/*<div
      className="rdg-cell"
      style={{
        left: props.rowProps.viewportColumns[5].left,
        width: props.rowProps.viewportColumns[5].width
      }}
    />*/}
    <div
      className="rdg-cell"
      style={{
        left: props.rowProps.viewportColumns[5].left,
        width: props.rowProps.viewportColumns[5].width
      }}
    >
      <div className="add-button">
        <button class="hidden-button" type="submit" />{/* for enter key to submit */}
        <Button
          type="primary"
          icon={<PlusOutlined />}
          shape="circle"
          size="default"
          onClick={handleSubmit}
        />
      </div>
    </div>
  </Form>
}
